import { useDispatch } from 'react-redux';
import { SnackbarArgs, activateSnackbar } from 'store/features/ui';

export const useSnackbar = () => {
    const dispatch = useDispatch();

    return (args: SnackbarArgs) => dispatch(activateSnackbar(args));
};
